module.exports = __webpack_public_path__ + "static/feather-3-7f9ebfca934a76a9afee8a61f97a18c5.png";